export enum StatoUnitaDocumentariaEnum {
  IN_LAVORAZIONE = <any>"IN_LAVORAZIONE",
  CHIUSO = <any>"CHIUSO",
  ARCHIVIATO = <any>"ARCHIVIATO",
  ANNULLATO = <any>"ANNULLATO",
  BLOCCATO = <any>"BLOCCATO",
  IN_BOZZA = <any>"IN_BOZZA",
}
